import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class LoginController {

  constructor(app) {
    this.app = app;
  }
  show(path, model) {
    const app = this.app;
    model = {
      resource: app.resource
    }
    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
  async loginEmail(email, password) {
    const app = this.app;
    if (!email) {
      app.showToast("Error: Missing email");
      return;
    }
    app.showToast("Logging in...");
    if (email) email = email.trim();
    try {
      const data = await app.login(email, password);
      if (data && data.id) {
        app.navigate("MainMenu");
        app.dataLoaded();
        app.save();
        app.showToast("Login Success");
      } else {
        app.showToast("Login failed");
      }
    } catch (e) {
      app.showToast("Login failed");
      console.log("Login failed", e);
    } finally {
    }
  }
  passwordReset(email) {
    const app = this.app;
    return app.accountJD.PasswordReset(email)
      .then(() => {
        app.showToast("Password reset sent to email");
      }).catch((e) => {
        app.showToast("Password reset error. " + e);
      });
  }
 

}